import type { DevSummaryFieldFragment as jiraBusinessDevSummaryField } from '@atlassian/jira-business-fields/src/common/field-types/dev-summary/fragment/__generated_apollo__/DevSummaryFieldFragment.ts';
import type { TransformedDevSummary } from '../types';

const hasPullRequest = (field: jiraBusinessDevSummaryField) =>
	Number(field?.devSummary?.pullrequest?.overall?.count) > 0;

const isUnderReview = (field: jiraBusinessDevSummaryField) =>
	hasPullRequest(field) && field?.devSummary?.pullrequest?.overall?.state === 'OPEN';

const isMerged = (field: jiraBusinessDevSummaryField) =>
	hasPullRequest(field) && field?.devSummary?.pullrequest?.overall?.state === 'MERGED';

export const transformDevSummaryField = (
	field: jiraBusinessDevSummaryField | null,
): TransformedDevSummary | null =>
	field
		? {
				pullRequestsCount: Number(field?.devSummary?.pullrequest?.overall?.count),
				isUnderReview: isUnderReview(field),
				isMerged: isMerged(field),
				commitCount: Number(field?.devSummary?.commit?.overall?.count),
			}
		: null;
